import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://167.71.62.249/';
const API_URL_WALLET = BASE_URL + 'payments/';

// Function to purchase tokens
const purchaseTokens = async (token, amount) => {
    try {
        const response = await axios.post(API_URL_WALLET + 'purchase-tokens/', { amount }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

const listPayments = async (token) => {
    try {
        const response = await axios.get(API_URL_WALLET + 'transactions', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        throw error;
    }
};

// Function to handle success
const getSuccessMessage = async () => {
    try {
        const response = await axios.get(API_URL_WALLET + 'success/');
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Function to handle cancellation or errors
const getErrorMessage = async () => {
    try {
        const response = await axios.get(API_URL_WALLET + 'cancel/');
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default {
    purchaseTokens,
    listPayments,
    getSuccessMessage,
    getErrorMessage
};
